import { render, staticRenderFns } from "./Response.vue?vue&type=template&id=84a14af0"
import script from "./Response.vue?vue&type=script&lang=ts"
export * from "./Response.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports